<template>
  <div class="dg-wrapper">
    <div class="dg-title mb-0">
      <div class="text-center text-white py-1">Void Label</div>
    </div>

    <div class="dg-body">
      <div v-if="options.html" class="dg-content" v-html="messageBody"></div>
      <div v-else class="dg-content">{{ messageBody }}</div>

      <div class="dg-content-footer text-right pt-0">
        <b-btn class="btn-new btn-light-blue-outline default" @click="handleDismiss" :options="options">Cancel</b-btn>
        <b-btn class="btn-new btn-red default" @click="handleShare" :options="options">
          <span class="spinner" v-if="isLoading"><i class="fa fa-spinner fa-spin fa-lg fa-fw"></i></span>
          <span v-else>Void</span>
        </b-btn>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
.void-dialog {
  .dg-main-content {
    padding: 0;
  }
  .dg-title {
    background-color: #c2341a;
    border-radius: 5px;
  }
  .dg-body {
    padding: 15px;
  }
  .spinner {
    padding: 0 13px;
  }
}
</style>

<script>
import DialogMixin from 'vuejs-dialog/dist/vuejs-dialog-mixin.min.js';

export default {
  mixins: [DialogMixin],
  data() {
    return {
      isLoading: false,
    }
  },
  methods: {
    handleShare() {
      this.isLoading = true
      this.proceed();
    },
    handleDismiss() {
      this.cancel();
    }
  },
};
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/Dialogs/Void.vue